<script setup lang="ts">
import type { FolderDto } from '@/models/library'

defineProps<{ folder: FolderDto }>()
const emit = defineEmits<{
  (e: 'open'): void
  (e: 'rename'): void
  (e: 'delete'): void
}>()
</script>

<template>
  <div class="folder-card">
    <button class="body" type="button" @click="emit('open')">
      <span class="icon">📁</span>
      <span class="info">
        <span class="name" :title="folder.name">{{ folder.name }}</span>
        <span class="count">{{ folder.scanCount }} scan{{ folder.scanCount === 1 ? '' : 's' }}</span>
      </span>
    </button>
    <div class="actions">
      <button class="icon-btn" title="Rename" @click.stop="emit('rename')">✏️</button>
      <button class="icon-btn" title="Delete" @click.stop="emit('delete')">🗑️</button>
    </div>
  </div>
</template>

<style scoped>
.folder-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  padding: 0.25rem 0.5rem 0.25rem 0.25rem;
}

.body {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  background: transparent;
  border: 0;
  color: var(--text);
  padding: 0.5rem;
  flex: 1;
  min-width: 0;
  cursor: pointer;
  text-align: left;
}

.icon {
  font-size: 1.6rem;
}

.info {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.name {
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.count {
  font-size: 0.75rem;
  color: var(--text-muted);
}

.actions {
  display: flex;
  gap: 0.15rem;
}

.icon-btn {
  background: transparent;
  border: 0;
  font-size: 0.95rem;
  padding: 0.3rem;
  border-radius: 8px;
  cursor: pointer;
}

.icon-btn:hover {
  background: var(--surface-2);
}
</style>
